export interface PatientScheduleDayResult {
  checked: boolean;
  /** Provider-local slot starts the patient is already booked over. */
  conflicts: string[];
}

/** One shared reference, so memos keyed on `conflicts` stay stable. */
export const UNCHECKED_PATIENT_SCHEDULE: PatientScheduleDayResult = {
  checked: false,
  conflicts: [],
};
